/*
    Block Details Page
*/

import { BlockDetails } from "./BlockDetails.container";

export default BlockDetails;
